import React, { useState, useCallback, useEffect } from "react";
import { get } from "lodash";
import PropTypes from "prop-types";
import { Modal, Header, Close, Body } from "MODULES/shared/components/Modal";
import { CACHED_SALES_CART } from "MODULES/users/constants";
import { connect } from "react-redux";
import { COMPANY } from "APP_ROOT/constants";
import Form from "./Form";

function Create({ cachedCart, open, close, lineItems }) {
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [preferredShippingMethods, setPreferredShippingMethods] = useState([]);

  useEffect(
    () => {
      setSelectedCustomer(get(cachedCart, COMPANY, null));
    },
    [get(cachedCart, "company.id")]
  );

  const [shippingToAddress, setShippingToAddress] = useState({});

  const onShippingAddressChange = useCallback(
    shippingType => address => {
      setShippingToAddress(addr => ({
        ...addr,
        [shippingType]: address
      }));
    },
    []
  );

  const onClose = useCallback(
    () => {
      close();

      setSelectedCustomer({});
      setShippingToAddress({});
    },
    [close]
  );

  return (
    <Modal open={open} close={onClose} dialogClass="modal-lg">
      <Header>
        <Close close={onClose} />
        <h4 className="modal-title">Create a New Sales Order</h4>
      </Header>
      <Body>
        <Form
          close={onClose}
          lineItems={lineItems}
          enableReinitialize
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          shippingToAddress={shippingToAddress}
          setShippingToAddress={onShippingAddressChange}
          preferredShippingMethods={preferredShippingMethods}
          setPreferredShippingMethods={setPreferredShippingMethods}
        />
      </Body>
    </Modal>
  );
}

export default connect(state => ({
  cachedCart: state.session.get(CACHED_SALES_CART)
    ? state.session.get(CACHED_SALES_CART).toJS()
    : {}
}))(Create);

Create.propTypes = {
  cachedCart: PropTypes.shape({}),
  open: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  lineItems: PropTypes.arrayOf(PropTypes.shape({}))
};



// WEBPACK FOOTER //
// ./app/modules/SalesOrders/components/ConvertFromCartForm/Create.jsx